import PropTypes from 'prop-types';
import React from 'react';
import FormattedTranslation from 'components/Common/FormattedTranslationMui';
import { Box, Checkbox, Typography } from '@mui/material';

export const KeepSessionCheckBox = ({ onSelect, isChecked }) => (
  <Box display="flex" alignItems="center" justifyContent="center">
    <Checkbox
      checked={isChecked}
      onChange={() => onSelect(!isChecked)}
    />
    <Typography>
      <FormattedTranslation id="page.login.checkbox.keepMeLoggedIn" />
    </Typography>
  </Box>
);

KeepSessionCheckBox.propTypes = {
  onSelect: PropTypes.func.isRequired,
  isChecked: PropTypes.bool,
};

KeepSessionCheckBox.defaultProps = {
  isChecked: false,
};

export default KeepSessionCheckBox;
